export const numberWithCommas = (x: string) => {
  return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const parseStringToWholeNumber = (num: string) => {
  // decimals are parsed to whole numbers (round-off)
  return parseInt(parseFloat(num).toFixed(0));
};
